module.exports = __webpack_public_path__ + "static/media/aws-certified-cloud-practitioner.4ecc88b1.png";